import { useMemo } from 'react';

export function usePasswordStrengthColor(passwordStrength: number) {
  return useMemo(() => {
    if (passwordStrength < 2) {
      return 'error';
    } else if (passwordStrength < 4) {
      return 'warning';
    } else {
      return 'secondary';
    }
  }, [passwordStrength]);
}
